export { default } from './support-v2-orders-list-page';
